module.exports = __webpack_public_path__ + "static/img/18-18.46b4083a.jpeg";